import Controller from '../abstracts/Controller';
import 'scss-templates/t-homepage.scss';

export default class HomepageController extends Controller {
  static get COMPONENTS() {
    return [
      'NewsletterComponent',
      'EditorialSliderComponent',
      'HeroComponent',
      'O2OComponent',
      'SimpleBarComponent',
      'GeneralComponentsComponent',
      'AddToWishlistComponent',
      'WishlistComponent',
      'CarouselComponent'
    ];
  }
}
